<template>
    <div>
        <nav-breadcrumb :menu="[{label: '债转审核'}]"/>

        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="180px">
                        <el-row>
                            <panel border>

                            <el-col :span="12" v-if="dataForm.t__transactionNo!=='待生成'">
                                <el-form-item label="债转编号：" style="width: 100%" prop="t__transactionNo" :rules="{required: true, message: '债转编号不能为空'}">
                                    <el-input v-model="dataForm.t__transactionNo" ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="dataForm.t__transactionNo=='待生成'">
                                <el-form-item label="债转编号：" style="width: 100%" prop="t__transactionNo" :rules="{required: true, message: '债转编号不能为空'}">
                                    <el-input v-model="dataForm.t__transactionNo" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" style="width: 100%">
                                    &nbsp;
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="转让人：" prop="t__frPartnerId" :rules="{required: true, message: '转让人不能为空'}" style="width: 100%">
                                    <el-select placeholder="请选择转让人" v-model.trim="dataForm.t__frPartnerId" style="width: 100%">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in partnerOptions1" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="法人：" prop="i__frContactPerson" style="width: 100%" >
                                    {{dataForm.i__frContactPerson}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="转让人户名：" prop="i__frAccountName" style="width: 100%" >
                                    {{dataForm.i__frAccountName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="开户银行：" prop="i__frBankName" style="width: 100%" >
                                    {{dataForm.i__frBankName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="银行账号：" prop="i__frAccountNo" style="width: 100%" >
                                    {{dataForm.i__frAccountNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" style="width: 100%">
                                    &nbsp;
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="受让人：" prop="t__toPartnerId" :rules="{required: true, message: '受让人不能为空'}" style="width: 100%">
                                    <el-select placeholder="请选择转让人" v-model.trim="dataForm.t__toPartnerId" style="width: 100%">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in partnerOptions2" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="法人："style="width: 100%" >
                                    {{dataForm.i__toContactPerson}}
                                </el-form-item>
                            </el-col>
                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="贷款信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm2" label-width="180px">
                        <el-row>
                            <panel border>

                            <el-col :span="12">
                                <el-form-item label="贷款合同：" style="width: 90%">
                                    {{dataForm.data1}}  &nbsp;&nbsp;&nbsp;&nbsp;<el-button type="small" @click="showDialog()">选择</el-button>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="贷款期限："  style="width: 100%">
                                    {{dataForm.data2}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="客户姓名："  style="width: 100%">
                                    {{dataForm.data3}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="身份证号："  style="width: 100%">
                                    {{dataForm.data4}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="贷款金额：" style="width: 100%">
                                    {{dataForm.t__totalAmount|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="担保编号："  style="width: 100%">
                                    {{dataForm.data5}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="抵押物："  style="width: 100%">
                                    {{dataForm.data6}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="已还款金额："  prop="t__repaymentAmount" :rules="{required: true, message: '不能为空'}"  style="width: 100%">
                                    <el-input v-model="dataForm.t__repaymentAmount" type="number" style="width: 50%"></el-input>  &nbsp;&nbsp;&nbsp;&nbsp;<el-button type="small" v-if="dataForm.t__referenceId" @click="showDialogTwo()">查看还款信息</el-button>
                                </el-form-item>
                            </el-col>
                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="债转信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm3" label-width="180px">
                        <el-row>
                            <panel border>

                            <el-col :span="12">
                                <el-form-item label="债转日期：" style="width: 100%"  prop="t__transactionDate" :rules="{required: true, message: '不能为空'}">
                                    <el-date-picker
                                        v-model="dataForm.t__transactionDate"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="已累计支付购买价款："  prop="t__swappedAmount" :rules="{required: true, message: '不能为空'}"  style="width: 100%">
                                    <el-input v-model="dataForm.t__swappedAmount" type="number"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付剩余本金："  prop="t__principalPayable" :rules="{required: true, message: '不能为空'}"  style="width: 100%">
                                    <el-input v-model="dataForm.t__principalPayable" type="number"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付利息："  prop="t__interestPayable" :rules="{required: true, message: '不能为空'}"  style="width: 100%">
                                    <el-input v-model="dataForm.t__interestPayable" type="number"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付罚息："  prop="t__overdueFinePayable" :rules="{required: true, message: '不能为空'}"  style="width: 100%">
                                    <el-input v-model="dataForm.t__overdueFinePayable" type="number"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="应付复利："  prop="t__compoundInterestPayable" :rules="{required: true, message: '不能为空'}"  style="width: 100%">
                                    <el-input v-model="dataForm.t__compoundInterestPayable" type="number"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="债转合计金额：" style="width: 100%">
                                    {{dataForm.t__netEquityValue|formatMoney}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="备注：">
                                    <el-input type="textarea" v-model="dataForm.t__remarks" style="margin-bottom:10px;"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            </panel>
                        </el-row>
                    </el-form>
                </panel>
            </el-col>
        </el-row>
        <el-dialog title="选择合同" :visible.sync="showDialogValue" width="60%" >
            <data-table :table-data="tableData" :columns="columns"
                        :page.sync="page"
                        :pageSize.sync="pageSize"
                        :filters.sync="filters" ></data-table>
        </el-dialog>
        <el-dialog title="查看还款信息" :visible.sync="showDialogValue2" width="60%" >
            <data-table
                :columns="RepayColumns"
                :table-data="{data:financingDetail.repayments.filter(item=>item.re__sequenceNo) }"
                :is-pagination-show="false"
            >
            </data-table>
        </el-dialog>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('dataForm','YZZ')">审核通过</el-button>
            <el-button @click="onSubmit('dataForm','Rejected')">否决</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import moment from 'moment'
    import Status2CN from "../../filters/Status2CN";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "ApproveEquitySwapTx",
        data(){
            return {
                page: 1,
                pageSize: 20,
                tableData: {
                    count: 0,
                    data: []
                },
                financingDetail :{
                    repayments:[],
                },
                RepayColumns:[
                    {
                        label:'期数',
                        field:'re__sequenceNo'
                    },
                    {
                        label: '应还款日',
                        field: 'plan__repayDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '实还款日',
                        field: 're__repayDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '到账金额',
                        field: 're__repayAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还本金',
                        field: 're__principalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还利息',
                        field: 're__interestAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还罚息',
                        field: 're__overdueFine',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '实还复利',
                        field: 're__compoundInterest',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    /*{
                    label: '提前还款违约金',
                    field: 're__penaltyAmount',
                    formatter: function (r,c,v) {
                    return formatMoney(v)+'元'
                    }
                    },*/
// {
//   label: '服务费',
//   field: 're__lendingFeeAmount',
//   formatter: function (r,c,v) {
//     return formatMoney(v)+'元'
//   }
// },
                    /* {
                    label: '其他费用',
                    field: 're__otherAmount',
                    formatter: function (r,c,v) {
                    return formatMoney(v)+'元'
                    }
                    },*/
                    {
                        label: '减免金额',
                        field: 're__deductionAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '上期余额',
                        field: 're__exBalanceAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },
                    {
                        label: '本期余额',
                        field: 're__excessAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)+'元'
                        }
                    },


                ],
                repaymentAmount:0,
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户名称',
                        field: 'ba__customerName'
                    },
                    {
                        label: '担保合同编号',
                        field: 'fi__warrantNo'
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '选择',
                                class: 'el-icon-finished',
                                clickHandler: (index, row)=> {
                                    this.dataForm.t__referenceId = row.fi__transactionId
                                    this.dataForm.data1 = row.fi__transactionNo
                                    this.dataForm.data2 = row.fi__startDate + '~' + row.fi__endDate
                                    this.dataForm.data3 = row.ba__customerName
                                    this.dataForm.data4 = row.ba__customerIC
                                    this.dataForm.t__totalAmount = row.fi__totalAmount
                                    this.dataForm.data5 = row.fi__warrantNo
                                    this.dataForm.data6 = row.fi__propertyLocation

                                    //  alert((parseFloat(row.re__regularPrincipalAmount)+parseFloat(this.dataForm.re__regularInterestAmount)).toFixed(2))
                                    this.dataForm.t__repaymentAmount = (parseFloat(row.re__regularPrincipalAmount)+parseFloat(row.re__regularInterestAmount)).toFixed(2)
                                    this.repaymentAmount =  this.dataForm.t__repaymentAmount
                                    this.dataForm.t__principalPayable = row.re__advancedPrincipalAmount
                                    this.dataForm.t__interestPayable = row.re__advancedInterestAmount
                                    this.dataForm.t__overdueFinePayable = row.re__advancedOverdueFine
                                    this.dataForm.t__compoundInterestPayable = row.re__advancedCompoundInterest
                                    this.dataForm.t__transactionDate = row.settle__settleDate
                                    this.changeValue()
                                    this.showDialogValue = false
                                }
                            },
                        ]
                    }

                ],

                showCol : true,
                showDialogValue:false,
                showDialogValue2:false,
                transactionId: this.$route.query['transactionId']||'',
                dataForm:{
                    t__transactionNo:'待生成',
                    t__transactionStatus: 'Pending Approval',
                    t__principalPayable:0,
                    t__interestPayable:0,
                    t__overdueFinePayable:0,
                    t__compoundInterestPayable:0,
                    t__repaymentAmount:0,
                    t__swappedAmount:0,
                    t__transactionDate:null,
                    data1:'',
                    data2:'',
                    data3:'',
                    data4:'',
                    data5:'',
                    data6:''
                },
                partnerOptions1:[
                ],
                partnerOptions2:[
                ],
                disabledOptions:[
                    {
                        label:'启用',
                        value:'N'
                    },
                    {
                        label:'禁用',
                        value:'Y'
                    },
                ],
                dataFormRules: {
                    i__bankName: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                    i__accountName: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                    i__accountNo: [
                        {
                            required: false,
                            message: '不能为空！'
                        }
                    ],
                },
                filters: {
                    labelWidth: '150px',
                    form: {
                        fi__transactionNo:'',
                        ba__customerName:'',
                    },
                    columns: [

                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo'
                        },
                        {
                            label: '客户名称',
                            component: 'el-input',
                            field: 'ba__customerName'
                        },

                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getEquitySwapCandidatesSelect()
                    }
                }
            }
        },
        computed: {
            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,


                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch:{
            'dataForm.t__swappedAmount':function () {
                this.changeValue()
                let  swappedAmount =this.dataForm.t__swappedAmount
                if(this.dataForm.t__swappedAmount==''){
                    swappedAmount=0
                }
                if(  this.repaymentAmount>0){
                    this.dataForm.t__repaymentAmount =  (parseFloat(this.repaymentAmount)
                        - parseFloat(swappedAmount)).toFixed(2)
                }
            },
            'dataForm.t__principalPayable':function () {
                this.changeValue()
            },
            'dataForm.t__interestPayable':function () {
                this.changeValue()
            },
            'dataForm.t__overdueFinePayable':function () {
                this.changeValue()
            },
            'dataForm.t__compoundInterestPayable':function () {
                this.changeValue()
            },
            'dataForm.t__frPartnerId':function () {

                this.dataForm.i__frContactPerson = (this.partnerOptions1.filter(item=>{return item.value == this.dataForm.t__frPartnerId })[0]||{}).p__contactPerson
                this.dataForm.i__frAccountName = (this.partnerOptions1.filter(item=>{return item.value == this.dataForm.t__frPartnerId })[0]||{}).i__accountName
                this.dataForm.i__frBankName = (this.partnerOptions1.filter(item=>{return item.value == this.dataForm.t__frPartnerId })[0]||{}).i__bankName
                this.dataForm.i__frAccountNo = (this.partnerOptions1.filter(item=>{return item.value == this.dataForm.t__frPartnerId })[0]||{}).i__accountNo
                this.dataForm.i__frPartnerName = (this.partnerOptions1.filter(item=>{return item.value == this.dataForm.t__frPartnerId })[0]||{}).label
                this.dataForm.i__frContactNo = (this.partnerOptions1.filter(item=>{return item.value == this.dataForm.t__frPartnerId })[0]||{}).i__contactNo

            },
            'dataForm.t__toPartnerId':function () {

                this.dataForm.i__toContactPerson = (this.partnerOptions2.filter(item=>{return item.value == this.dataForm.t__toPartnerId })[0]||{}).p__contactPerson
                this.dataForm.i__toAccountName = (this.partnerOptions2.filter(item=>{return item.value == this.dataForm.t__toPartnerId })[0]||{}).i__accountName
                this.dataForm.i__toBankName =(this.partnerOptions2.filter(item=>{return item.value == this.dataForm.t__toPartnerId })[0]||{}).i__bankName
                this.dataForm.i__toAccountNo = (this.partnerOptions2.filter(item=>{return item.value == this.dataForm.t__toPartnerId })[0]||{}).i__accountNo
                this.dataForm.i__toPartnerName = (this.partnerOptions2.filter(item=>{return item.value == this.dataForm.t__toPartnerId })[0]||{}).label
                this.dataForm.i__toContactNo = (this.partnerOptions2.filter(item=>{return item.value == this.dataForm.t__toPartnerId })[0]||{}).i__contactNo
            },
            filterParams: function (newVal) {
                this.getEquitySwapCandidatesSelect()
            }
        },
        mounted() {
            this.getPartnerOptions()
            setTimeout(() =>{
                if(this.transactionId){
                    this.getData()
                }
            },200);


        },
        methods:{
            data : function () {
                xhr.getFinancingFang({
                    'fi.transactionId': this.dataForm.t__referenceId
                }, res=>{
                    try{
                        if(res.data.status == 'success') {
                            this.financingDetail = res.data.data


                        }
                    }catch(e){}
                })

            },
            changeValue :function() {
                this.dataForm.t__netEquityValue =( parseFloat(this.dataForm.t__swappedAmount) + parseFloat(this.dataForm.t__principalPayable) +parseFloat(this.dataForm.t__interestPayable) +parseFloat(this.dataForm.t__overdueFinePayable)+parseFloat(this.dataForm.t__compoundInterestPayable)).toFixed(2)

            },
            showDialog: function () {
                this.showDialogValue = true
                this.getEquitySwapCandidatesSelect()
            },
            showDialogTwo: function () {
                this.showDialogValue2 = true
                this.data()
            },
            getEquitySwapCandidatesSelect : function () {
                xhr.getEquitySwapCandidatesSelect(
                    Object.assign({},  this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })
            },
            getEquitySwapCandidatesSelect2 : function (referenceId) {
                xhr.getEquitySwapCandidatesSelect(
                    Object.assign({
                        'fi.transactionId':referenceId,
                    }, {}, {}),
                    res=> {
                        try {
                            let row = res.data.data[0]
                            this.dataForm.data1 = row.fi__transactionNo
                            this.dataForm.data2 = row.fi__startDate + '至' + row.fi__endDate
                            this.dataForm.data3 = row.ba__customerName
                            this.dataForm.data4 = row.ba__customerIC
                            this.dataForm.data5 = row.fi__warrantNo
                            this.dataForm.data6 = row.fi__propertyLocation
                            this.repaymentAmount =  this.dataForm.t__repaymentAmount
                        }catch(e){

                        }
                    })
            },
            getPartnerOptions: function () {
                xhr.getPartnerOptions(
                    Object.assign({
                    }, {}, {}),
                    res=> {
                        try {

                            this.partnerOptions1 = res.data.data.filter(items=>{return items.p__partnerType=='ZRR' }).map(item=>{

                                return {
                                    label: item.p__partnerName,
                                    value:item.p__partnerId,
                                    p__contactPerson:item.p__contactPerson,
                                    i__accountName:item.i__accountName,
                                    i__bankName:item.i__bankName,
                                    i__accountNo:item.i__accountNo,
                                    i__contactNo:item.i__contactNo,
                                }


                            })
                            this.partnerOptions2 = res.data.data.filter(items=>{return items.p__partnerType=='SRR' }).map(item=>{

                                return {
                                    label: item.p__partnerName,
                                    value:item.p__partnerId,
                                    p__contactPerson:item.p__contactPerson,
                                    i__accountName:item.i__accountName,
                                    i__bankName:item.i__bankName,
                                    i__accountNo:item.i__accountNo,
                                    i__contactNo:item.i__contactNo,
                                }


                            })
                        }catch(e){

                        }
                    })

            },

            getData:function(){
                xhr.getEquitySwapTx({
                        't.transactionId': this.transactionId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {

                                let  dataForm = res.data.data
                                if(dataForm.data1){

                                }else{
                                    dataForm.data1 = null
                                }
                                if(dataForm.data2){

                                }else{
                                    dataForm.data2 = null
                                }
                                if(dataForm.data3){

                                }else{
                                    dataForm.data3 = null
                                }
                                if(dataForm.data4){

                                }else{
                                    dataForm.data4 = null
                                }
                                if(dataForm.data5){

                                }else{
                                    dataForm.data5 = null
                                }
                                if(dataForm.data6){

                                }else{
                                    dataForm.data6 = null
                                }
                                this.dataForm = dataForm
                                this.getEquitySwapCandidatesSelect2(this.dataForm.t__referenceId)
                            }
                        }catch (e) {

                        }
                    })
            },
            onSubmit: function (formName,status) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.$refs['dataForm2'].validate(valid2=> {
                            if (valid2) {
                                this.$refs['dataForm3'].validate(valid3=> {
                                    if (valid3) {
                                        dataForm.a__checked = true
                                        dataForm.a__approvingStatus= status
                                        dataForm.a__applicationTypeCode = '-'
                                        xhr.approveEquitySwapTx(dataForm, res=> {
                                            try {
                                                if (res.data.status == 'success') {
                                                    this.$router.push({
                                                        name: 'ApproveEquitySwapTxListView'
                                                    })
                                                }
                                            } catch (e) {

                                            }
                                        })
                                    }
                                })

                            }
                        })

                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApproveEquitySwapTx.vue